import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  LinearProgress,
  CircularProgress,
  Alert,
} from "@mui/material";
import noData from "../../images/noData.jpg";
import { toast } from "react-toastify";
import NotoSansRegular from "../../fonts/NotoSans-Regular.ttf";
import NotoSansBold from "../../fonts/NotoSans-Bold.ttf";
import NotoSansSymbols from "../../fonts/NotoSansSymbols-Regular.ttf";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import verifyImg from "../../images/check-mark.png";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import blankA4 from "../../pdf/blankA4.pdf";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import html2canvas from "html2canvas";
import fontkit from "@pdf-lib/fontkit";
import BarcodeFont from "./free3of9/fre3of9x.ttf";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import QRCode from "qrcode";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { BASE_URL } from "../../constants";
import dayjs from "dayjs";
import { useRecoilState, useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useNavigate } from "react-router-dom";
import JsBarcode from "jsbarcode";

import {
  microbiologyReportState,
  microbiologyReportsLoadedState,
  rowLoadingState,
  formattedFromDateState,
  formattedToDateState,
  fromDateState,
  toDateState,
} from "../../recoil/microbiologyReportState";
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const MicrobiologyReportsDynamics = () => {
  // const [microbiologies, setMicrobiologies] = useState([]);
  const navigate = useNavigate();
  const user = useRecoilValue(authState);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pdfTemplate, setPdfTemplate] = useState("");
  const getFormattedDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Extracts YYYY-MM-DD from ISO format
  };
  // const [fromDate, setFromDate] = useState(getFormattedDate());
  // const [toDate, setToDate] = useState(getFormattedDate());
  // const [formattedFromDate, setFormattedFromDate] = useState(
  //   getFormattedCurrentDate()
  // );
  // const [formattedToDate, setFormattedToDate] = useState(
  //   getFormattedCurrentDate()
  // );
  const [uploadingMicroId, setUploadingMicroId] = useState(null);

  const [microbiologyReportsLoaded, setMicrobiologyReportsLoaded] =
    useRecoilState(microbiologyReportsLoadedState);
  const [microbiologyReport, setMicrobiologyReport] = useRecoilState(
    microbiologyReportState,
  );
  const [fromDate, setFromDate] = useRecoilState(fromDateState);
  const [toDate, setToDate] = useRecoilState(toDateState);
  const [rowLoading, setRowLoading] = useRecoilState(rowLoadingState);
  const [formattedFromDate, setFormattedFromDate] = useRecoilState(
    formattedFromDateState,
  );
  const [formattedToDate, setFormattedToDate] =
    useRecoilState(formattedToDateState);

  const formatDateToReadableString = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    const formattedDay = day < 10 ? `0${day}` : day;
    return `${month} ${formattedDay}, ${year}`;
  };
  const showAgeInReport = (dob) => {
    const birthDate = dayjs(dob, "MMMM DD, YYYY");
    const today = dayjs();

    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const days = today.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // "Feb"
    const year = date.getFullYear().toString().slice(-2); // "25"
    return `${day}-${month}-${year}`;
  }
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // "Feb"
    const year = date.getFullYear().toString().slice(-2); // "25"
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = String(hours % 12 || 12).padStart(2, "0"); // Ensure 2-digit hours
    const formattedMinutes = String(minutes).padStart(2, "0"); // Ensure 2-digit minutes

    return `${day}-${month}-${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
  }
  const fetchPdfTemplate = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}api/user/common/get-pdfTemplate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setPdfTemplate(data.pdf.orgReportPdfUrl);
    } catch (error) {}
  };

  const [microLayout, setMicroLayout] = useState("");
  const fetchMicroLayout = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/user/microbiology/layout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setMicroLayout(data?.layout);
    } catch (error) {}
  };

  const [microCache, setMicroCache] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const fetchAllMicrobiologyReports = async (
    page = 0,
    limit = 10,
    query = "",
    fromDateParam = formattedFromDate,
    toDateParam = formattedToDate,
  ) => {
    try {
      // ================== ✅ DATE RANGE VALIDATION ==================
      if (formattedFromDate && formattedToDate) {
        const from = new Date(formattedFromDate);
        const to = new Date(formattedToDate);

        const diffTime = Math.abs(to - from);
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays > 92) {
          toast.error("You can select maximum 3 months date range");
          setRowLoading(false);
          return;
        }
      }
      setRowLoading(true);

      const endpoint = query
        ? `${BASE_URL}api/user/microbiology/search-reports?query=${encodeURIComponent(
            query,
          )}&page=${page}&limit=${limit}&startDate=${fromDateParam}&endDate=${toDateParam}`
        : `${BASE_URL}api/user/microbiology/get-microbiology-reports?page=${page}&limit=${limit}&startDate=${fromDateParam}&endDate=${toDateParam}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const micro = await response.json();

      if (micro.success) {
        const reqData = micro?.data?.map((d) => ({
          _id: d._id,
          invoice: d?.invoice?.invoiceId,
          doctorName: d?.doctorId?.name,
          patientName: d?.patientId?.name,
          report: d?.result,
          createdAt: d?.createdAt,
          patientId: d?.patientId,
          doctorId: d?.doctorId,
          centreId: d?.invoice?.centerId,
          reportFileUrl: d?.reportFileUrl,
          overallStatus: d?.overallStatus,
          signatoryDoctor: d?.doctorSignatory,
          techSignatory: d?.techSignatory,
        }));

        const cacheKey = `${query}_${page}_${limit}_${fromDateParam}_${toDateParam}`;

        setMicroCache((prev) => ({
          ...prev,
          [cacheKey]: {
            data: reqData,
            totalCount: micro.totalCount,
          },
        }));

        setMicrobiologyReport(reqData);
        setTotalCount(micro.totalCount || reqData.length);
        setMicrobiologyReportsLoaded(true);
      } else {
        setMicrobiologyReport([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setRowLoading(false);
    }
  };
  useEffect(() => {
    const cacheKey = `${searchQuery}_${page}_${rowsPerPage}_${formattedFromDate}_${formattedToDate}`;

    if (microCache[cacheKey]) {
      setMicrobiologyReport(microCache[cacheKey].data);
      setTotalCount(microCache[cacheKey].totalCount);
    } else {
      fetchAllMicrobiologyReports(
        page,
        rowsPerPage,
        searchQuery,
        formattedFromDate,
        formattedToDate,
      );
    }
  }, [page, rowsPerPage, searchQuery]);
  useEffect(() => {
    fetchAllMicrobiologyReports();
    fetchPdfTemplate();
    fetchMicroLayout();
  }, []);
  const handleReload = () => {
    fetchAllMicrobiologyReports();
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search Filter
  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    setPage(0); // Reset to first page on new search
  };

  const paginatedMicros = microbiologyReport;

  function formatDate(inputDate) {
    const dateObj = new Date(inputDate);
    const day = dateObj.getDate().toString().padStart(2, "0");
    const monthShort = dateObj.toLocaleString("default", { month: "short" });
    const yearShort = dateObj.getFullYear().toString().slice(-2);
    return `${day}-${monthShort}-${yearShort}`;
  }
  function formatTime(dateString) {
    const dateObj = new Date(dateString);
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // '0' hour should be '12'
    const formattedHours = hours.toString().padStart(2, "0");

    return `${formattedHours}:${minutes} ${ampm}`;
  }

  const addHeader1 = async (
    microbiology,
    page,
    pageNumber,
    totalPage,
    normalFont,
    boldFont,
    barcodeFont,
    report,
    pdfDoc,
    sDate,
    sTime,
  ) => {
    let yPosition = page.getHeight() - 220;
    const headerFontSize = 10;
    const labelFontSize = 10;
    const rightXPosition = 300;
    const rightXPosition2 = 380;
    const leftXPosition = 76;
    const pageWidth = page.getWidth();
    const patientFontSize = 11;
    const restFontSize = 9;
    const margin = 20;
    // Header Background with Rounded Corners
    page.drawRectangle({
      x: 10,
      y: yPosition + 10,
      width: pageWidth - 20,
      height: 95,
      color: rgb(0.98, 0.98, 0.98), // Soft gray background
      borderColor: rgb(0.8, 0.8, 0.8),
      borderWidth: 0.7,
    });

    yPosition += 90;
    page.drawText(`${microbiology.patientId.name}`, {
      x: 25,
      y: yPosition,
      size: patientFontSize,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Invoice ID
    page.drawText("UHID", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${microbiology.patientId.patientID}`, {
      x: rightXPosition2,
      y: yPosition,
      size: 11,
      font: boldFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    yPosition -= 15;

    // Gender / Age
    page.drawText("Sex / Age", {
      x: 25,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(
      `: ${microbiology.patientId.gender} / ${showAgeInReport(
        microbiology.patientId.dob,
      )}`,
      {
        x: leftXPosition,
        y: yPosition,
        size: restFontSize,
        font: normalFont,
        color: rgb(0.2, 0.2, 0.2),
      },
    );

    page.drawText("Case ID", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${microbiology.invoice}`, {
      x: rightXPosition2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Mobile Number
    yPosition -= 15;
    page.drawText("Mobile", {
      x: 25,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${microbiology.patientId.mobile}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    page.drawText("Sample Collected", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${formatDate(sDate)} ${sTime}`, {
      x: rightXPosition2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Referred By
    yPosition -= 15;
    page.drawText("Ref. By", {
      x: 25,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${microbiology.doctorId.name}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
    page.drawText("Report Generated", {
      x: rightXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${formatDateTime(microbiology.createdAt)}`, {
      x: rightXPosition2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // Center
    yPosition -= 15;
    page.drawText("Center", {
      x: 25,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });

    //vertical line
    page.drawLine({
      start: { x: 280, y: 635 }, // Bottom point
      end: { x: 280, y: 720 }, // Top point (50px above)
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });
    page.drawLine({
      start: { x: 480, y: 635 }, // Bottom point
      end: { x: 480, y: 720 }, // Top point (50px above)
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });
    page.drawText(`: ${microbiology.centreId.centreId}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });
    // page.drawText("*" + microbiology.invoice + "*", {
    //   x: rightXPosition,
    //   y: yPosition - 15,
    //   size: 30,
    //   font: barcodeFont,
    // });
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, microbiology.invoice, {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });
    const barcodeImage = barcodeCanvas.toDataURL("image/png");
    const barcodeBytes = await fetch(barcodeImage).then((res) =>
      res.arrayBuffer(),
    );
    const barcodeImg = await page.doc.embedPng(barcodeBytes);
    page.drawImage(barcodeImg, {
      x: rightXPosition - 6,
      y: yPosition - 17,
      width: 180,
      height: 30,
    });

    yPosition -= 15;
    page.drawText("Lab ID", {
      x: 25,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.1, 0.1, 0.1),
    });
    page.drawText(`: ${localStorage.getItem("orgID").replaceAll("-", ".")}`, {
      x: leftXPosition,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
      color: rgb(0.2, 0.2, 0.2),
    });

    // const pages = pdfDoc.getPages();
    // for (let page of pages) {
    page.drawText("This is a verified report", {
      x: 500,
      y: 650,
      font: normalFont,
      size: 7,
    });
    const imageResponse = await fetch(verifyImg);
    const imageBuffer = await imageResponse.arrayBuffer();
    let Image = await pdfDoc.embedPng(imageBuffer);
    page.drawImage(Image, {
      x: 513,
      y: 660,
      width: 50,
      height: 50,
    });

    // const signatoryDoctor = report?.doctorSignatory;
    // console.log("signatoryDoctor", signatoryDoctor);
    // let Width = page.getWidth();
    // let startDocSignPosition = margin;
    // for (let i = 0; i < signatoryDoctor?.length; i++) {
    //   if (signatoryDoctor[i].doctor.signwebLink !== "") {
    //     const imageResponse = await fetch(
    //       signatoryDoctor[i].doctor.signwebLink
    //     );
    //     const imageBuffer = await imageResponse.arrayBuffer();
    //     const contentType = imageResponse.headers.get("content-type");
    //     let pdfImage;
    //     if (contentType.includes("png") || contentType.includes("webp")) {
    //       pdfImage = await pdfDoc.embedPng(imageBuffer);
    //     } else if (
    //       contentType.includes("jpeg") ||
    //       contentType.includes("jpg")
    //     ) {
    //       pdfImage = await pdfDoc.embedJpg(imageBuffer);
    //     } else {
    //       console.warn("Unsupported image format, trying PNG conversion.");
    //       return;
    //     }
    //     const imgDims = pdfImage.scale(0.5);
    //     page.drawImage(pdfImage, {
    //       x: Width - 130,
    //       y: 80,
    //       width: imgDims.width, //100,
    //       height: imgDims.height, //100,
    //     });
    //     startDocSignPosition -= 100;
    //   }
    //   let signHeaderY = 70;
    //   const noteLines = signatoryDoctor[i].doctor.signHeader.split(/\s{2,}/g);
    //   for (const line of noteLines) {
    //     page.drawText(`${line.trim()}`, {
    //       x: Width - 130,
    //       y: signHeaderY - 2,
    //       size: 9,
    //     });
    //     signHeaderY -= 10;
    //   }
    //   Width -= 100;
    // }
    const signatoryDoctor = report?.doctorSignatory || [];
    console.log("signatoryDoctor", signatoryDoctor);

    let Width = page.getWidth();
    for (let i = 0; i < signatoryDoctor.length; i++) {
      const signLink = signatoryDoctor[i]?.doctor?.signwebLink;
      if (!signLink) continue;

      try {
        const imageResponse = await fetch(signLink);
        const imageBuffer = await imageResponse.arrayBuffer();
        const contentType = imageResponse.headers.get("content-type") || "";

        let pdfImage;
        if (contentType.includes("png") || contentType.includes("webp")) {
          pdfImage = await pdfDoc.embedPng(imageBuffer);
        } else if (
          contentType.includes("jpeg") ||
          contentType.includes("jpg")
        ) {
          pdfImage = await pdfDoc.embedJpg(imageBuffer);
        } else {
          console.warn("Unsupported image format:", contentType);
          continue; // skip instead of return
        }

        const imgDims = pdfImage.scale(0.5);
        const xPosition = Width - 130 - i * 100;

        page.drawImage(pdfImage, {
          x: xPosition,
          y: 80,
          width: imgDims.width,
          height: imgDims.height,
        });

        // draw header text
        let signHeaderY = 70;
        const noteLines = (signatoryDoctor[i]?.doctor?.signHeader || "").split(
          /\s{2,}/g,
        );
        for (const line of noteLines) {
          page.drawText(line.trim(), {
            x: xPosition,
            y: signHeaderY - 2,
            size: 9,
            font: normalFont,
          });
          signHeaderY -= 10;
        }
      } catch (err) {
        console.error("Error embedding doctor sign:", err);
      }
    }

    // const signatoryTech = report?.techSignatory;
    // let startSignPosition = margin;
    // for (let i = 0; i < signatoryTech?.length; i++) {
    //   if (signatoryTech[i]?.technician?.techSignWebLink !== "") {
    //     const imageResponse = await fetch(
    //       signatoryTech[i]?.technician?.techSignWebLink
    //     );
    //     const imageBuffer = await imageResponse.arrayBuffer();
    //     const contentType = imageResponse.headers.get("content-type");
    //     let pdfImage;
    //     if (contentType.includes("png") || contentType.includes("webp")) {
    //       pdfImage = await pdfDoc.embedPng(imageBuffer);
    //     } else if (
    //       contentType.includes("jpeg") ||
    //       contentType.includes("jpg")
    //     ) {
    //       pdfImage = await pdfDoc.embedJpg(imageBuffer);
    //     } else {
    //       console.warn("Unsupported image format, trying PNG conversion.");
    //       return;
    //     }
    //     const imgDims = pdfImage.scale(0.5);
    //     page.drawImage(pdfImage, {
    //       x: startSignPosition,
    //       y: 80,
    //       width: imgDims.width, //50,
    //       height: imgDims.height, // 50,
    //     });
    //   }
    //   let techSignHeaderY = 70;
    //   const techNoteLines =
    //     signatoryTech[i]?.technician?.technicianHeader.split(/\s{2,}/g);
    //   for (const line of techNoteLines) {
    //     page.drawText(`${line.trim()}`, {
    //       x: startSignPosition,
    //       y: techSignHeaderY - 2,
    //       size: 9,
    //     });
    //     techSignHeaderY -= 10;
    //   }
    //   startSignPosition += 80;
    // }

    const signatoryTech = report?.techSignatory || [];
    let startSignPosition = margin;

    for (let i = 0; i < signatoryTech.length; i++) {
      const techLink = signatoryTech[i]?.technician?.techSignWebLink;
      if (!techLink) continue;

      try {
        const imageResponse = await fetch(techLink);
        const imageBuffer = await imageResponse.arrayBuffer();
        const contentType = imageResponse.headers.get("content-type") || "";

        let pdfImage;
        if (contentType.includes("png") || contentType.includes("webp")) {
          pdfImage = await pdfDoc.embedPng(imageBuffer);
        } else if (
          contentType.includes("jpeg") ||
          contentType.includes("jpg")
        ) {
          pdfImage = await pdfDoc.embedJpg(imageBuffer);
        } else {
          console.warn("Unsupported technician image format:", contentType);
          continue; // skip invalid image but don’t break loop
        }

        const imgDims = pdfImage.scale(0.5);

        page.drawImage(pdfImage, {
          x: startSignPosition,
          y: 80,
          width: imgDims.width,
          height: imgDims.height,
        });

        // draw technician header text under signature
        let techSignHeaderY = 70;
        const techNoteLines = (
          signatoryTech[i]?.technician?.technicianHeader || ""
        ).split(/\s{2,}/g);

        for (const line of techNoteLines) {
          page.drawText(line.trim(), {
            x: startSignPosition,
            y: techSignHeaderY - 2,
            size: 9,
            font: normalFont,
          });
          techSignHeaderY -= 10;
        }

        startSignPosition += 80; // move next signature to the right
      } catch (err) {
        console.error("Error embedding technician sign:", err);
      }
    }
  };

  const embedImageSafe = async (pdfDoc, url) => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();

      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

      try {
        return await pdfDoc.embedPng(bytes);
      } catch {
        try {
          return await pdfDoc.embedJpg(bytes);
        } catch {
          console.warn("Unsupported image:", url);
          return null;
        }
      }
    } catch (err) {
      console.error("Image failed:", url, err);
      return null;
    }
  };
  const addHeader2 = async (
    microbiology,
    page,
    pageNumber,
    totalPage,
    normalFont,
    boldFont,
    barcodeFont,
    report,
    pdfDoc,
    sDate,
    sTime,
  ) => {
    const pageHeight = page.getHeight();
    const pageWidth = page.getWidth();

    // ===============================
    // 🔥 USE microLayout DIRECTLY
    // ===============================
    const headerX = Number(microLayout?.header?.position?.x || 10);
    const headerY = Number(microLayout?.header?.position?.y || 40);
    const headerWidth = Number(
      microLayout?.header?.size?.width || pageWidth - 20,
    );
    const headerHeight = Number(microLayout?.header?.size?.height || 100);

    const patientW = Number(
      microLayout?.header?.columns?.patient?.width || 250,
    );
    const uhidW = Number(microLayout?.header?.columns?.uhid?.width || 150);
    const qrW = Number(microLayout?.header?.columns?.qr?.width || 100);
    const margin = 20;
    // ===============================
    // 🔹 Y Conversion (IMPORTANT)
    // ===============================
    const headerTopY = pageHeight - headerY;
    const headerBottomY = headerTopY - headerHeight;

    let yPosition = headerTopY - 15;

    const leftX = headerX + 15;
    const rightX = headerX + patientW + 10;
    const rightX2 = rightX + 80;

    const patientFontSize = 11;
    const restFontSize = 9;

    // ===============================
    // 🔹 HEADER BOX
    // ===============================
    page.drawRectangle({
      x: headerX,
      y: headerBottomY,
      width: headerWidth,
      height: headerHeight,
      color: rgb(0.98, 0.98, 0.98),
      borderColor: rgb(0.8, 0.8, 0.8),
      borderWidth: 0.7,
    });

    // ===============================
    // 🔹 PATIENT NAME
    // ===============================
    page.drawText(`${microbiology.patientId.name}`, {
      x: leftX,
      y: yPosition,
      size: patientFontSize,
      font: boldFont,
    });

    // ===============================
    // 🔹 UHID
    // ===============================
    page.drawText("UHID", {
      x: rightX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${microbiology.patientId.patientID}`, {
      x: rightX2,
      y: yPosition,
      size: 11,
      font: boldFont,
    });

    yPosition -= 15;

    // ===============================
    // 🔹 SEX / AGE
    // ===============================
    page.drawText("Sex / Age", {
      x: leftX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(
      `: ${microbiology.patientId.gender} / ${showAgeInReport(
        microbiology.patientId.dob,
      )}`,
      {
        x: leftX + 60,
        y: yPosition,
        size: restFontSize,
        font: normalFont,
      },
    );

    page.drawText("Case ID", {
      x: rightX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${microbiology.invoice}`, {
      x: rightX2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    yPosition -= 15;

    // ===============================
    // 🔹 MOBILE + SAMPLE
    // ===============================
    page.drawText("Mobile", {
      x: leftX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${microbiology.patientId.mobile}`, {
      x: leftX + 60,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText("Sample Collected", {
      x: rightX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${formatDate(sDate)} ${sTime}`, {
      x: rightX2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    yPosition -= 15;

    // ===============================
    // 🔹 REF BY + GENERATED
    // ===============================
    page.drawText("Ref. By", {
      x: leftX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${microbiology.doctorId.name}`, {
      x: leftX + 60,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText("Report Generated", {
      x: rightX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${formatDateTime(microbiology.createdAt)}`, {
      x: rightX2,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    yPosition -= 15;

    // ===============================
    // 🔹 CENTER
    // ===============================
    page.drawText("Center", {
      x: leftX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${microbiology.centreId.centreId}`, {
      x: leftX + 60,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    yPosition -= 15;
    // ===============================
    // 🔥 BARCODE FINAL FIXED VERSION
    // ===============================
    const barcodeCanvas = document.createElement("canvas");

    barcodeCanvas.width = 400;
    barcodeCanvas.height = 120;

    const barcodeValue =
      microbiology?.invoice || microbiology?.invoiceId || "123456";

    console.log("BARCODE VALUE:", barcodeValue);

    // Generate barcode
    JsBarcode(barcodeCanvas, barcodeValue.toString(), {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });

    // 🔥 FIX: base64 → Uint8Array (NO fetch)
    const base64Data = barcodeCanvas.toDataURL("image/png").split(",")[1];

    const barcodeBytes = Uint8Array.from(atob(base64Data), (c) =>
      c.charCodeAt(0),
    );

    // 🔥 FIX: use pdfDoc
    const barcodeImage = await pdfDoc.embedPng(barcodeBytes);

    // Position
    const barcodeY = headerBottomY + 10;

    page.drawImage(barcodeImage, {
      x: rightX,
      y: yPosition - 5, //barcodeY,
      width: 180,
      height: 30,
    });

    // ===============================
    // 🔹 LAB ID
    // ===============================
    page.drawText("Lab ID", {
      x: leftX,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    page.drawText(`: ${localStorage.getItem("orgID").replaceAll("-", ".")}`, {
      x: leftX + 60,
      y: yPosition,
      size: restFontSize,
      font: normalFont,
    });

    const signatoryDoctor = report?.doctorSignatory || [];
    console.log("signatoryDoctor", signatoryDoctor);

    let Width = page.getWidth();
    for (let i = 0; i < signatoryDoctor.length; i++) {
      const signLink = signatoryDoctor[i]?.doctor?.signwebLink;
      if (!signLink) continue;

      try {
        const imageResponse = await fetch(signLink);
        const imageBuffer = await imageResponse.arrayBuffer();
        const contentType = imageResponse.headers.get("content-type") || "";

        let pdfImage;
        if (contentType.includes("png") || contentType.includes("webp")) {
          pdfImage = await pdfDoc.embedPng(imageBuffer);
        } else if (
          contentType.includes("jpeg") ||
          contentType.includes("jpg")
        ) {
          pdfImage = await pdfDoc.embedJpg(imageBuffer);
        } else {
          console.warn("Unsupported image format:", contentType);
          continue; // skip instead of return
        }

        const imgDims = pdfImage.scale(0.5);
        const xPosition = Width - 130 - i * 100;

        page.drawImage(pdfImage, {
          x: xPosition,
          y: 80,
          width: imgDims.width,
          height: imgDims.height,
        });

        // draw header text
        let signHeaderY = 70;
        const noteLines = (signatoryDoctor[i]?.doctor?.signHeader || "").split(
          /\s{2,}/g,
        );
        for (const line of noteLines) {
          page.drawText(line.trim(), {
            x: xPosition,
            y: signHeaderY - 2,
            size: 9,
            font: normalFont,
          });
          signHeaderY -= 10;
        }
      } catch (err) {
        console.error("Error embedding doctor sign:", err);
      }
    }

    const signatoryTech = report?.techSignatory || [];
    let startSignPosition = margin;

    for (let i = 0; i < signatoryTech.length; i++) {
      const techLink = signatoryTech[i]?.technician?.techSignWebLink;
      if (!techLink) continue;

      try {
        const imageResponse = await fetch(techLink);
        const imageBuffer = await imageResponse.arrayBuffer();
        const contentType = imageResponse.headers.get("content-type") || "";

        let pdfImage;
        if (contentType.includes("png") || contentType.includes("webp")) {
          pdfImage = await pdfDoc.embedPng(imageBuffer);
        } else if (
          contentType.includes("jpeg") ||
          contentType.includes("jpg")
        ) {
          pdfImage = await pdfDoc.embedJpg(imageBuffer);
        } else {
          console.warn("Unsupported technician image format:", contentType);
          continue; // skip invalid image but don’t break loop
        }

        const imgDims = pdfImage.scale(0.5);

        page.drawImage(pdfImage, {
          x: startSignPosition,
          y: 80,
          width: imgDims.width,
          height: imgDims.height,
        });

        // draw technician header text under signature
        let techSignHeaderY = 70;
        const techNoteLines = (
          signatoryTech[i]?.technician?.technicianHeader || ""
        ).split(/\s{2,}/g);

        for (const line of techNoteLines) {
          page.drawText(line.trim(), {
            x: startSignPosition,
            y: techSignHeaderY - 2,
            size: 9,
            font: normalFont,
          });
          techSignHeaderY -= 10;
        }

        startSignPosition += 80; // move next signature to the right
      } catch (err) {
        console.error("Error embedding technician sign:", err);
      }
    }
  };

  const embedImageAuto = async (pdfDoc, buffer) => {
    try {
      return await pdfDoc.embedPng(buffer);
    } catch {
      try {
        return await pdfDoc.embedJpg(buffer);
      } catch {
        console.warn("Unsupported image format");
        return null;
      }
    }
  };
  const addHeader = async (
    microbiology,
    page,
    pageNumber,
    totalPage,
    normalFont,
    boldFont,
    barcodeFont,
    report,
    pdfDoc,
    sDate,
    sTime,
  ) => {
    const pageHeight = page.getHeight();
    const pageWidth = page.getWidth();

    // ================= HEADER LAYOUT =================
    const headerX = Number(microLayout?.header?.position?.x || 10);
    const headerY = Number(microLayout?.header?.position?.y || 40);
    const headerWidth = Number(
      microLayout?.header?.size?.width || pageWidth - 20,
    );
    const headerHeight = Number(microLayout?.header?.size?.height || 100);

    const patientW = Number(
      microLayout?.header?.columns?.patient?.width || 250,
    );
    const uhidW = Number(microLayout?.header?.columns?.uhid?.width || 150);

    const headerTopY = pageHeight - headerY;
    const headerBottomY = headerTopY - headerHeight;

    let yPosition = headerTopY - 15;

    const leftX = headerX + 15;
    const rightX = headerX + patientW + 10;
    const rightX2 = rightX + 80;

    // ================= HEADER BOX =================
    page.drawRectangle({
      x: headerX,
      y: headerBottomY,
      width: headerWidth,
      height: headerHeight,
      color: rgb(0.98, 0.98, 0.98),
      borderColor: rgb(0.8, 0.8, 0.8),
      borderWidth: 0.7,
    });

    // ================= TEXT =================
    page.drawText(`${microbiology.patientId.name}`, {
      x: leftX,
      y: yPosition,
      size: 11,
      font: boldFont,
    });

    page.drawText("UHID", {
      x: rightX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${microbiology.patientId.patientID}`, {
      x: rightX2,
      y: yPosition,
      size: 11,
      font: boldFont,
    });

    yPosition -= 15;

    page.drawText("Sex / Age", {
      x: leftX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(
      `: ${microbiology.patientId.gender} / ${showAgeInReport(microbiology.patientId.dob)}`,
      { x: leftX + 60, y: yPosition, size: 9, font: normalFont },
    );

    page.drawText("Case ID", {
      x: rightX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${microbiology.invoice}`, {
      x: rightX2,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    yPosition -= 15;

    page.drawText("Mobile", {
      x: leftX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${microbiology.patientId.mobile}`, {
      x: leftX + 60,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    page.drawText("Sample Collected", {
      x: rightX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${formatDate(sDate)} ${sTime}`, {
      x: rightX2,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    yPosition -= 15;

    page.drawText("Ref. By", {
      x: leftX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${microbiology.doctorId.name}`, {
      x: leftX + 60,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    page.drawText("Report Generated", {
      x: rightX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${formatDateTime(microbiology.createdAt)}`, {
      x: rightX2,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    yPosition -= 15;

    page.drawText("Center", {
      x: leftX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${microbiology.centreId.centreId}`, {
      x: leftX + 60,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    yPosition -= 15;

    page.drawLine({
      start: {
        x: Number(microLayout?.header?.columns?.patient?.width),
        y: Number(pageHeight - microLayout?.header?.position?.y) - 95,
      }, // was 635
      end: {
        x: microLayout?.header?.columns?.patient?.width,
        y: Number(pageHeight - microLayout?.header?.position?.y),
      }, // was 720
      thickness: 0.7,
      color: rgb(0.8, 0.8, 0.8),
    });

    // ================= BARCODE =================
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, microbiology?.invoice?.toString() || "123", {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });

    const base64 = canvas.toDataURL("image/png").split(",")[1];
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

    const barcodeImage = await pdfDoc.embedPng(bytes);

    page.drawImage(barcodeImage, {
      x: rightX,
      y: yPosition - 5,
      width: 180,
      height: 30,
    });

    page.drawText("Lab ID", {
      x: leftX,
      y: yPosition,
      size: 9,
      font: normalFont,
    });
    page.drawText(`: ${localStorage.getItem("orgID").replaceAll("-", ".")}`, {
      x: leftX + 60,
      y: yPosition,
      size: 9,
      font: normalFont,
    });

    // ================= SIGNATURES USING microLayout =================

    // ===== DOCTOR SIGNATURE =====
    const doctorPos = microLayout?.footer?.doctorSignature?.position;
    const doctorSize = microLayout?.footer?.doctorSignature?.size;

    for (let i = 0; i < report?.doctorSignatory?.length; i++) {
      const link = report.doctorSignatory[i]?.doctor?.signwebLink;
      if (!link) continue;

      try {
        const res = await fetch(link);
        const buffer = await res.arrayBuffer();

        const pdfImage = await embedImageAuto(pdfDoc, buffer);
        if (!pdfImage) continue;

        const x = doctorPos?.x || 400;

        // ✅ Correct Y (NO magic offsets)
        const baseY = page.getHeight() - (doctorPos?.y || 100);

        // ✅ Handle multiple doctors (stack vertically)
        const y = baseY - i * (doctorSize?.height + 20);

        page.drawImage(pdfImage, {
          x,
          y,
          width: doctorSize?.width || 100,
          height: doctorSize?.height || 50,
        });

        // ===== Doctor Text =====
        let textY = y - 12;

        const lines = (
          report.doctorSignatory[i]?.doctor?.signHeader || ""
        ).split(/\s{2,}/g);

        for (const line of lines) {
          page.drawText(line.trim(), {
            x,
            y: textY,
            size: 9,
            font: normalFont,
          });
          textY -= 10;
        }
      } catch (err) {
        console.error("Doctor sign error:", err);
      }
    }

    // ===== TECHNICIAN SIGNATURE =====
    const techPos = microLayout?.footer?.technicianSignature?.position;
    const techSize = microLayout?.footer?.technicianSignature?.size;

    for (let i = 0; i < report?.techSignatory?.length; i++) {
      const link = report.techSignatory[i]?.technician?.techSignWebLink;
      if (!link) continue;

      try {
        const res = await fetch(link);
        const buffer = await res.arrayBuffer();

        const pdfImage = await embedImageAuto(pdfDoc, buffer);
        if (!pdfImage) continue;

        const x = techPos?.x || 50;

        // ✅ Correct Y (NO magic offsets)
        const baseY = page.getHeight() - (techPos?.y || 100);

        // ✅ Handle multiple technicians
        const y = baseY - i * (techSize?.height + 20);

        page.drawImage(pdfImage, {
          x,
          y,
          width: techSize?.width || 100,
          height: techSize?.height || 50,
        });

        // ===== Technician Text =====
        let textY = y - 12;

        const lines = (
          report.techSignatory[i]?.technician?.technicianHeader || ""
        ).split(/\s{2,}/g);

        for (const line of lines) {
          page.drawText(line.trim(), {
            x,
            y: textY,
            size: 9,
            font: normalFont,
          });
          textY -= 10;
        }
      } catch (err) {
        console.error("Technician sign error:", err);
      }
    }
  };

  const handleGeneratePDF = async (microbiology, withTemplate) => {
    if (uploadingMicroId != null) return;
    setUploadingMicroId(microbiology._id);
    try {
      const templatePath = withTemplate ? pdfTemplate : blankA4;

      const templatePdfBytes = await fetch(templatePath).then((res) =>
        res.arrayBuffer(),
      );

      const templatePdf = await PDFDocument.load(templatePdfBytes);
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);

      // load unicode fonts
      const normalFontBytes = await fetch(NotoSansRegular).then((res) =>
        res.arrayBuffer(),
      );
      const boldFontBytes = await fetch(NotoSansBold).then((res) =>
        res.arrayBuffer(),
      );
      const symbolFontBytes = await fetch(NotoSansSymbols).then((res) =>
        res.arrayBuffer(),
      );
      const symbolFont = await pdfDoc.embedFont(symbolFontBytes);
      const boldFont = await pdfDoc.embedFont(boldFontBytes);
      const normalFont = await pdfDoc.embedFont(normalFontBytes);
      const fontBytes = await fetch(BarcodeFont).then((res) =>
        res.arrayBuffer(),
      );
      const barcodeFont = await pdfDoc.embedFont(fontBytes);

      const fontSize = 12;
      const lineHeight = 20;
      //const marginTop = 225;
      const marginLeft = 20;
      const marginRight = 20;
      const paddingInsideCell = 5;

      for (const [indx, report] of microbiology.report.entries()) {
        const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
        const newPage = pdfDoc.addPage(templatePage);
        const margin = 20;
        const sDate = report.sampleCollectedDate;
        const sTime = report.sampleCollectedTime;
        await addHeader(
          microbiology,
          newPage,
          indx,
          microbiology.report.length,
          normalFont,
          boldFont,
          barcodeFont,
          report,
          pdfDoc,
          sDate,
          sTime,
          report,
        );
        const { width, height } = newPage.getSize();
        // ================================
        // 🔥 DYNAMIC HEADER + CONTENT (microLayout)
        // ================================
        const headerY = microLayout?.header?.position?.y || 40;
        const headerHeight = microLayout?.header?.size?.height || 100;

        const headerTopY = height - headerY;
        const headerBottomY = headerTopY - headerHeight;

        // 🔥 CONTENT START (same as radiology)
        const contentStartY =
          height - (microLayout?.content?.position?.y || 220);

        let y = contentStartY - 15;
        let yPosition = contentStartY - 15;

        // 🔥 CONTENT BOX
        const contentX = microLayout?.content?.position?.x || 20;

        const contentWidth = microLayout?.content?.size?.width || width - 40;

        const contentHeight =
          microLayout?.content?.size?.height || headerBottomY - 80;
        //let y = height - marginTop;
        const { investigation } = report;
        newPage.drawRectangle({
          x: contentX,
          y: y,
          width: contentWidth,
          height: 15,
          color: rgb(0.94, 0.94, 0.94),
        });

        const titleWidth = normalFont.widthOfTextAtSize(
          report?.testName || "Test",
          10,
        );

        newPage.drawText(report?.testName || "Test", {
          x: contentX + (contentWidth - titleWidth) / 2,
          y,
          size: 14,
          font: boldFont,
          color: rgb(0.502, 0, 0.125),
        });
        y -= lineHeight;
        // Draw SPECIMEN if exists
        if (investigation.specimen) {
          newPage.drawText(`SPECIMEN`, {
            x: contentX,
            y,
            size: fontSize,
            font: boldFont,
            color: rgb(0, 0, 0),
          });
          newPage.drawText(": " + investigation.specimen, {
            x: contentX + 105,
            y,
            size: fontSize,
            font: normalFont,
            color: rgb(0, 0, 0),
          });
          y -= lineHeight;
        }

        let currentPage = newPage;
        if (investigation.resultType === "negative") {
          const result = await renderHtmlSectionToPdf({
            label: "",
            htmlContent: investigation.text,
            startY: y + 20,
            currentPage,
            pdfDoc,
            templatePdf,
            width,
            margin: marginLeft,
            indx,
            addHeader,
            microbiology,
            normalFont,
            boldFont,
            barcodeFont,
            report,
            sDate,
            sTime,
          });

          y = result.yAfterSection;
          currentPage = result.currentPage;
        }
        if (investigation.resultType === "positive") {
          if (investigation.organism) {
            newPage.drawText(`ORGANISM`, {
              x: contentX,
              y,
              size: fontSize,
              font: boldFont,
              color: rgb(0, 0, 0),
            });
            newPage.drawText(": " + investigation.organism, {
              x: contentX + 105,
              y,
              size: fontSize,
              font: normalFont,
              color: rgb(0, 0, 0),
            });
            y -= lineHeight;
          }
          if (investigation.colonyCount) {
            const drawMixedText = (text, x, y) => {
              let cursorX = x;
              for (let char of text) {
                const isSymbol = ["≥", "≤", "∞"].includes(char);
                const fontToUse = isSymbol ? symbolFont : normalFont;
                newPage.drawText(char, {
                  x: cursorX,
                  y,
                  size: fontSize,
                  font: fontToUse,
                });
                const width = fontToUse.widthOfTextAtSize(char, fontSize);
                cursorX += width;
              }
            };
            newPage.drawText(`COLONY COUNT `, {
              x: contentX,
              y,
              size: fontSize,
              font: boldFont,
              color: rgb(0, 0, 0),
            });

            drawMixedText(": " + investigation.colonyCount, contentX + 105, y);
            y -= lineHeight;
          }
          y -= lineHeight;
          // Draw table headers
          const headers = ["Sensitive", "Intermediate", "Resistant"];
          const tableX = contentX;
          const tableWidth = contentWidth;
          const colWidth = tableWidth / 3;
          const rowHeight = lineHeight;

          headers.forEach((header, i) => {
            const cellX = tableX + i * colWidth;
            newPage.drawRectangle({
              x: cellX,
              y: y - 2,
              width: colWidth,
              height: rowHeight,
              borderColor: rgb(0, 0, 0),
              borderWidth: 1,
            });
            newPage.drawText(header, {
              x: cellX + paddingInsideCell,
              y: y + 3,
              size: fontSize,
              font: boldFont,
              color: rgb(0, 0, 0),
            });
          });
          y -= rowHeight;

          const maxRows = Math.max(
            investigation.sensitive?.length || 0,
            investigation.intermediate?.length || 0,
            investigation.resistant?.length || 0,
          );

          for (let i = 0; i < maxRows; i++) {
            const rowY = y;
            const sensitiveVal = investigation.sensitive[i] || "";
            const intermediateVal = investigation.intermediate[i] || "";
            const resistantVal = investigation.resistant[i] || "";

            [sensitiveVal, intermediateVal, resistantVal].forEach(
              (val, colIdx) => {
                const cellX = tableX + colIdx * colWidth;

                newPage.drawRectangle({
                  x: cellX,
                  y: rowY - 2,
                  width: colWidth,
                  height: rowHeight,
                  borderColor: rgb(0, 0, 0),
                  borderWidth: 1,
                });

                newPage.drawText(val, {
                  x: cellX + paddingInsideCell,
                  y: rowY + 3,
                  size: fontSize,
                  font: normalFont,
                  color: rgb(0, 0, 0),
                });
              },
            );

            y -= rowHeight;
          }
        }
        async function renderHtmlSectionToPdf({
          label,
          htmlContent,
          startY,
          currentPage,
          pdfDoc,
          templatePdf,
          width,
          margin,
          indx,
          addHeader,
          microbiology,
          normalFont,
          boldFont,
          barcodeFont,
          report,
          sDate,
          sTime,
        }) {
          currentPage.drawText(label, {
            x: contentX,
            y: startY,
            size: 12,
            font: boldFont,
            color: rgb(0, 0, 0),
          });

          //   startY -= 10;
          let currentY = startY;

          const tempDiv = document.createElement("div");
          tempDiv.id = "RQ";
          tempDiv.style.position = "absolute";
          tempDiv.style.top = "-9999px";
          tempDiv.style.left = "-9999px";
          tempDiv.style.width = `${contentWidth}px`;
          tempDiv.style.maxWidth = `${contentWidth}px`;
          tempDiv.style.overflow = "hidden";
          tempDiv.style.margin = "0";
          tempDiv.style.padding = "0";
          tempDiv.style.paddingBottom = "20px";
          //tempDiv.style.paddingLeft = "27px";
          //tempDiv.innerHTML = htmlContent.replace(/width:\s*\d+px/g, "");
          tempDiv.style.border = "none";
          tempDiv.style.boxSizing = "border-box";
          //tempDiv.innerHTML = htmlContent;
          tempDiv.innerHTML = htmlContent
            .replace(/width:\s*\d+px/g, "")
            .replace(/<table/g, '<table style="width:100%;table-layout:fixed"');

          const styleTag = document.createElement("style");
          styleTag.innerHTML = `
            #RQ {
              margin: 0;
              font-size: 13px !important;
              font-family: Arial, sans-serif;
              white-space: pre-wrap;
            }

            #RQ p, #RQ div {
              white-space: pre-wrap;
              margin-bottom: -5px;
            }

            /* 🔥 FORCE TABLE FULL WIDTH */
            #RQ table {
              width: 100% !important;
              max-width: 100% !important;
              table-layout: fixed !important;
              border-collapse: collapse !important;
            }

            #RQ th, #RQ td {
              width: auto !important;
              word-break: break-word !important;
              white-space: normal !important;
            }

            #RQ img {
              max-width: 100% !important;
              height: auto !important;
            }

            .ql-align-center { text-align: center; }
            .ql-align-right { text-align: right; }
            .ql-align-left { text-align: left; }

            strong { font-weight: bold; }
            u { text-decoration: underline; }
          `;
          tempDiv.appendChild(styleTag);
          document.body.appendChild(tempDiv);

          const canvas = await html2canvas(tempDiv, {
            backgroundColor: null,
            scale: 3,
            scrollX: 0,
            scrollY: 0,
            useCORS: true,
          });

          document.body.removeChild(tempDiv);

          const imgData = canvas.toDataURL("image/png");
          const pngImage = await pdfDoc.embedPng(imgData);
          const pngDims = pngImage.scale(1);
          //const targetScale = (width - 100) / pngDims.width;
          const targetScale = contentWidth / pngDims.width;
          let startCanvasY = 0;
          const totalCanvasHeight = canvas.height;
          let pageIndex = indx;

          const pageHeight = currentPage.getSize().height;
          let usableHeight = contentHeight; //usableHeight = currentY - 130; // First page: from currentY
          let singlePageCanvasHeight = usableHeight / targetScale;

          while (startCanvasY < totalCanvasHeight) {
            const sliceHeight = Math.min(
              singlePageCanvasHeight,
              totalCanvasHeight - startCanvasY,
            );

            const splitCanvas = document.createElement("canvas");
            splitCanvas.width = canvas.width;
            splitCanvas.height = sliceHeight;

            const splitCtx = splitCanvas.getContext("2d");
            splitCtx.drawImage(
              canvas,
              0,
              startCanvasY,
              canvas.width,
              sliceHeight,
              0,
              0,
              canvas.width,
              sliceHeight,
            );

            const splitImgData = splitCanvas.toDataURL("image/png");
            const splitPngImage = await pdfDoc.embedPng(splitImgData);
            const splitDims = splitPngImage.scale(targetScale);

            const drawY = currentY - splitDims.height;

            currentPage.drawImage(splitPngImage, {
              x: contentX,
              y: drawY,
              width: splitDims.width,
              height: splitDims.height,
            });

            currentY = drawY;
            startCanvasY += sliceHeight;

            // If more slices are left, add a new page
            if (startCanvasY < totalCanvasHeight) {
              const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              pageIndex++;

              await addHeader(
                microbiology,
                currentPage,
                pageIndex,
                microbiology.report.length,
                normalFont,
                boldFont,
                barcodeFont,
                report,
                pdfDoc,
                sDate,
                sTime,
                report,
              );

              // Reset Y and usable height for the new page
              currentY = contentStartY; //currentY = 626.92; //pageHeight - 225;
              usableHeight = contentHeight;
              singlePageCanvasHeight = usableHeight / targetScale;
            }
          }

          return {
            yAfterSection: currentY - 10,
            currentPage,
          };
        }

        // let currentPage = newPage; // start from newPage
        //let y = height - 240; // or your desired initial Y
        if (report?.investigation?.note) {
          const result = await renderHtmlSectionToPdf({
            label: "Note:",
            htmlContent: report?.investigation?.note,
            startY: y,
            currentPage,
            pdfDoc,
            templatePdf,
            width,
            margin: marginLeft,
            indx,
            addHeader,
            microbiology,
            normalFont,
            boldFont,
            barcodeFont,
            report,
            sDate,
            sTime,
          });

          y = result.yAfterSection;
          currentPage = result.currentPage;
        }

        if (report?.testId?.interpretation) {
          const result = await renderHtmlSectionToPdf({
            label: "Interpretation:",
            htmlContent: report.testId.interpretation,
            startY: y,
            currentPage,
            pdfDoc,
            templatePdf,
            width,
            margin: marginLeft,
            indx,
            addHeader,
            microbiology,
            normalFont,
            boldFont,
            barcodeFont,
            report,
            sDate,
            sTime,
          });

          y = result.yAfterSection;
          currentPage = result.currentPage;
        }
      }

      for (let pg of pdfDoc.getPages()) {
        const imgWidth = 50;
        const imgHeight = 50;
        const textSize = 6;
        const text = "This is a verified report";
        const gap = 4;

        // ── QR Column X (MICRO LAYOUT) ─────────────
        const qrBoxLeftX =
          microLayout.header.position.x +
          microLayout.header.columns.patient.width +
          microLayout.header.columns.uhid.width;

        const qrBoxWidth = microLayout.header.columns.qr.width;

        // ── Header Y ───────────────────────────────
        const headerTopY = pg.getHeight() - microLayout.header.position.y;

        const headerHeight = microLayout.header.size.height;
        const headerBottomY = headerTopY - headerHeight;

        // ── Center Calculation ─────────────────────
        const textWidth = normalFont.widthOfTextAtSize(text, textSize);
        const totalBlockHeight = imgHeight + gap + textSize;

        const centerX = qrBoxLeftX + qrBoxWidth / 2;
        const centerY = headerBottomY + headerHeight / 2;

        const blockBottomY = centerY - totalBlockHeight / 2;

        // ── Load Image (IMPORTANT FIX) ─────────────
        const imageResponse = await fetch(verifyImg);
        const imageBuffer = await imageResponse.arrayBuffer();
        const verifyImage = await pdfDoc.embedPng(imageBuffer);

        // ── Draw Image ─────────────────────────────
        pg.drawImage(verifyImage, {
          x: centerX - imgWidth / 2,
          y: blockBottomY + textSize + gap,
          width: imgWidth,
          height: imgHeight,
        });

        // ── Draw Text ──────────────────────────────
        pg.drawText(text, {
          x: centerX - textWidth / 2,
          y: blockBottomY,
          font: normalFont,
          size: textSize,
        });

        // const qrCodeDataUrl = await QRCode.toDataURL(
        //   microbiology.reportFileUrl,
        //   { margin: 0 },
        // );

        if (!withTemplate) {
          const qrCodeDataUrl = await QRCode.toDataURL(
            microbiology.reportFileUrl,
            { margin: 0 },
          );
          const qrBytes = await fetch(qrCodeDataUrl).then((r) =>
            r.arrayBuffer(),
          );
          const qrImage = await pdfDoc.embedPng(qrBytes);

          const qrWidth = 71;
          const qrHeight = 65;

          pg.drawImage(qrImage, {
            x: centerX - imgWidth / 2 - 10,
            y: blockBottomY - 3,
            width: qrWidth,
            height: qrHeight,
          });
        }
      }

      const totalPages = pdfDoc.getPageCount();
      for (let i = 0; i < totalPages; i++) {
        const page = pdfDoc.getPage(i);
        const footerText = `Page ${i + 1} of ${totalPages}`;
        page.drawText(footerText, {
          x: 545,
          y: 38,
          font: normalFont,
          size: 8,
          color: rgb(0, 0, 0),
        });
      }
      // const pdfBytes1 = await pdfDoc.save();
      // const blob1 = new Blob([pdfBytes1], { type: "application/pdf" });
      // const url1 = URL.createObjectURL(blob1);
      // window.open(url1, "_blank");
      // return;
      const pdfBytes = await pdfDoc.save();

      if (!withTemplate) {
        // Generate QR
        const qrCodeDataUrl = await QRCode.toDataURL(
          microbiology.reportFileUrl,
          {
            margin: 0,
          },
        );
        console.log("Report URL:", microbiology.reportFileUrl);

        const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
          res.arrayBuffer(),
        );

        const qrImage = await pdfDoc.embedPng(qrImageBytes);

        const pages = pdfDoc.getPages();

        const qrImgWidth = 71;
        const qrImgHeight = 65;

        pages.forEach((page) => {
          const headerX = microLayout.header.position.x;
          const headerY = microLayout.header.position.y;
          const headerHeight = microLayout.header.size.height;

          const patientW = microLayout.header.columns.patient.width;
          const uhidW = microLayout.header.columns.uhid.width;
          const qrW = microLayout.header.columns.qr.width;

          const qrBoxLeftX = headerX + patientW + uhidW;

          const headerTopY = page.getHeight() - headerY;
          const headerBottomY = headerTopY - headerHeight;

          const gap = 4;
          const textSize = 7;
          const totalBlockHeight = qrImgHeight + gap + textSize;

          const centerX = qrBoxLeftX + qrW / 2;
          const centerY = headerBottomY + headerHeight / 2;

          const blockBottomY = centerY - totalBlockHeight / 2;

          page.drawImage(qrImage, {
            x: centerX - qrImgWidth / 2,
            y: blockBottomY,
            width: qrImgWidth,
            height: qrImgHeight,
          });
        });

        const finalBytes = await pdfDoc.save();
        const blob = new Blob([finalBytes], {
          type: "application/pdf",
        });

        window.open(URL.createObjectURL(blob), "_blank");

        return;
      }
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const file = new File([blob], "report.pdf", { type: "application/pdf" });
      const formData = new FormData();
      formData.append("pdfFile", file);
      try {
        const response = await fetch(
          `${BASE_URL}api/user/microbiology/upload-microbiology-report/${microbiology._id}`,
          {
            method: "POST",
            headers: {},
            body: formData,
          },
        );

        const result = await response.json();

        // 🔥 Handle backend errors (due, permission, etc.)
        if (!response.ok || !result?.success) {
          toast.error(result?.message || "Failed to upload report");
          return;
        }

        // ✅ Success
        toast.success(result.message);

        setMicrobiologyReport((prevMicrobiologies) =>
          prevMicrobiologies.map((m) =>
            m._id === result.data._id
              ? {
                  ...m,
                  reportFileUrl: result.data.reportFileUrl,
                }
              : m,
          ),
        );
      } catch (error) {
        console.error("Error uploading PDF:", error);

        // 🔥 Network / unexpected errors
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.log("ASASAS", err);
    } finally {
      setUploadingMicroId(null);
    }
  };

  const logPrintReport = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}api/user/common/log-print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, print: "microbiologyReport" }),
      });
    } catch (error) {
      console.log(error);
    }
  };

  const viewReport = async (micro) => {
    try {
      let fileUrl = micro.reportFileUrl;
      setUploadingMicroId(micro._id);

      // ✅ Fetch PDF
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to fetch PDF");

      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      // ✅ Generate QR
      const qrCodeDataUrl = await QRCode.toDataURL(fileUrl, { margin: 0 });
      const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
        res.arrayBuffer(),
      );
      const qrImage = await pdfDoc.embedPng(qrImageBytes);

      const pages = pdfDoc.getPages();

      const qrImgWidth = 71;
      const qrImgHeight = 65;

      pages.forEach((page) => {
        const pageHeight = page.getHeight();

        // ✅ Layout config (same pattern as pathology)
        const headerX = microLayout.header.position.x;
        const headerY = microLayout.header.position.y;
        const headerHeight = microLayout.header.size.height;

        const patientW = microLayout.header.columns.patient.width;
        const uhidW = microLayout.header.columns.uhid.width;
        const qrW = microLayout.header.columns.qr.width;

        // 🔑 QR column left edge
        const qrBoxLeftX = headerX + patientW + uhidW;

        // 🔑 Center horizontally
        const qrX = qrBoxLeftX + (qrW - qrImgWidth) / 2;

        // 🔑 Convert Y (pdf-lib origin bottom-left)
        const headerTopY = pageHeight - headerY;
        const headerBottomY = headerTopY - headerHeight;

        // 🔑 Vertical center
        const qrY = headerBottomY + headerHeight / 2 - qrImgHeight / 2;

        // ✅ Draw QR
        page.drawImage(qrImage, {
          x: qrX,
          y: qrY,
          width: qrImgWidth,
          height: qrImgHeight,
        });
      });

      // ✅ Save & Open
      const updatedPdfBytes = await pdfDoc.save();
      const blob = new Blob([updatedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      // logPrintReport(radiology._id);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error fetching or processing PDF:", error);
      alert("Failed to load the report. Please try again.");
    } finally {
      setUploadingMicroId(null);
    }
  };

  const printWithoutTemplate = async (micro) => {
    try {
      setUploadingMicroId(micro._id);

      // ✅ Load blank A4 template
      const templatePdfBytes = await fetch(blankA4).then((res) =>
        res.arrayBuffer(),
      );

      const templatePdf = await PDFDocument.load(templatePdfBytes);

      // ✅ Create new PDF
      const pdfDoc = await PDFDocument.create();

      // ✅ Copy first page from template
      const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);

      // ✅ Add copied page
      const page = pdfDoc.addPage(templatePage);

      // ✅ Generate QR (point to actual report URL)
      const qrCodeDataUrl = await QRCode.toDataURL(micro.reportFileUrl, {
        margin: 0,
      });

      const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
        res.arrayBuffer(),
      );

      const qrImage = await pdfDoc.embedPng(qrImageBytes);

      const qrImgWidth = 71;
      const qrImgHeight = 65;

      const pageHeight = page.getHeight();

      // ✅ Layout config
      const headerX = microLayout.header.position.x;
      const headerY = microLayout.header.position.y;
      const headerHeight = microLayout.header.size.height;

      const patientW = microLayout.header.columns.patient.width;
      const uhidW = microLayout.header.columns.uhid.width;
      const qrW = microLayout.header.columns.qr.width;

      // QR column left edge
      const qrBoxLeftX = headerX + patientW + uhidW;

      // Center horizontally
      const qrX = qrBoxLeftX + (qrW - qrImgWidth) / 2;

      // Convert Y (pdf-lib origin is bottom-left)
      const headerTopY = pageHeight - headerY;
      const headerBottomY = headerTopY - headerHeight;

      // Vertical center
      const qrY = headerBottomY + headerHeight / 2 - qrImgHeight / 2;

      // ✅ Draw QR
      page.drawImage(qrImage, {
        x: qrX,
        y: qrY,
        width: qrImgWidth,
        height: qrImgHeight,
      });

      // ✅ Save & Open
      const pdfBytes = await pdfDoc.save();

      const blob = new Blob([pdfBytes], {
        type: "application/pdf",
      });

      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate report. Please try again.");
    } finally {
      setUploadingMicroId(null);
    }
  };

  const viewReport1 = async (micro) => {
    try {
      let fileUrl = micro.reportFileUrl;
      setUploadingMicroId(micro._id);
      // Fetch the PDF from the URL
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to fetch PDF");

      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      // Generate QR Code
      const qrCodeDataUrl = await QRCode.toDataURL(fileUrl, {
        margin: 0,
      });
      const qrImageBytes = await fetch(qrCodeDataUrl).then((res) =>
        res.arrayBuffer(),
      );
      const qrImage = await pdfDoc.embedPng(qrImageBytes);

      // Embed QR Code in all pages
      const pages = pdfDoc.getPages();
      pages.forEach((page) => {
        page.drawImage(qrImage, {
          x: 500,
          y: 645, // Adjust Y position (bottom of the page)
          width: 71,
          height: 65,
        });
      });

      // Save the modified PDF
      const updatedPdfBytes = await pdfDoc.save();
      const blob = new Blob([updatedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      logPrintReport(micro._id);
      // Open the modified PDF in a new tab
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error fetching or processing PDF:", error);
      toast.error("Failed to load the report. Please try again.");
    } finally {
      setUploadingMicroId(null);
    }
  };

  const editReport = (micro) => {
    navigate("/dashboard/lab/microbiology", {
      state: { micro },
    });
  };
  // const [reportLimitAlert, setReportLimitAlert] = useState(false);
  // const [alertMessage, setAlertMessage] = useState("");
  return (
    <Box>
      {/* {reportLimitAlert && (
        <Alert
          severity="warning"
          onClose={() => {
            setReportLimitAlert(false);
          }}
        >
          {alertMessage}
        </Alert>
      )} */}
      <TableContainer
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          mt: 1,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 2,
              marginLeft: 5,
            }}
          >
            <Typography>From: </Typography>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value); // Store in YYYY-MM-DD for input
                setFormattedFromDate(
                  formatDateToReadableString(e.target.value),
                ); // Store in readable format
              }}
              style={{
                // width: "100%",
                padding: "6px 8px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
                transition: "all 0.3s ease-in-out",
                boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
                marginRight: 5,
              }}
            />
            <Typography>To: </Typography>
            <input
              type="date"
              value={toDate} // Bind with the correct format for the input
              onChange={(e) => {
                setToDate(e.target.value); // Store in YYYY-MM-DD for input
                setFormattedToDate(formatDateToReadableString(e.target.value)); // Store in readable format
              }}
              style={{
                // width: "100%",
                padding: "6px 8px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                outline: "none",
                transition: "all 0.3s ease-in-out",
                boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            />
            {fromDate && toDate && (
              <ContentPasteSearchIcon
                onClick={fetchAllMicrobiologyReports}
                sx={{ fontSize: "2rem", color: "#ef2d56", cursor: "pointer" }}
              />
            )}
          </div>
          {paginatedMicros && (
            <TablePagination
              component="div"
              count={totalCount} // ✅ server count
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
        {/* Search and Reload */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Chip
            avatar={
              <Avatar
                sx={{
                  backgroundColor: "#d0f0c0",
                  color: "#000",
                }}
              >
                {totalCount}
              </Avatar>
            }
            label="microbiology"
            color="success"
          />
          <TextField
            placeholder="Search radiology"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearch}
            sx={{
              width: "20%",
              ml: "auto",
            }}
          />
          <button
            onClick={handleReload}
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              background: "none",
              cursor: "pointer",
              padding: "8px",
            }}
          >
            <RefreshIcon style={{ color: "#1976d2", fontSize: "24px" }} />
          </button>
        </Box>
        <Table>
          {/* Table Head */}
          <TableHead
            sx={{
              backgroundColor: "#d9e2ff",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#5c6bc0",
                textTransform: "uppercase",
              },
            }}
          >
            <TableRow>
              <TableCell>Invoice ID</TableCell>
              <TableCell>Patient Name</TableCell>
              <TableCell>Doctor Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
            {rowLoading && (
              <TableRow>
                <TableCell colSpan={4} sx={{ padding: 0 }}>
                  <LinearProgress
                    color="success"
                    sx={{ height: 2, width: "100%" }}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {paginatedMicros?.map((micro, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8ff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  },
                  transition:
                    "background-color 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <TableCell>{micro?.invoice}</TableCell>
                <TableCell>{micro?.patientId?.name}</TableCell>
                <TableCell>{micro?.doctorId?.name}</TableCell>
                <TableCell>
                  <Tooltip title="Edit Report" arrow placement="top">
                    <IconButton size="small" onClick={() => editReport(micro)}>
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  {micro?.reportFileUrl?.length > 0 ? (
                    uploadingMicroId === micro?._id ? (
                      <IconButton size="small">
                        <CircularProgress size={24} color="success" />
                      </IconButton>
                    ) : (
                      <>
                        <Tooltip
                          title="Print report with template"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            onClick={() => viewReport(micro)}
                          >
                            <NoteAddIcon sx={{ color: "#2a9d8f" }} size={24} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title="Print report without template"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleGeneratePDF(micro, false)}
                            disabled={uploadingMicroId === micro._id}
                          >
                            <ContentCopyIcon
                              sx={{ color: "#e63946" }}
                              size={24}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )
                  ) : (
                    <Tooltip title="Upload Report" arrow placement="top">
                      <IconButton
                        size="small"
                        onClick={() => handleGeneratePDF(micro, true)}
                        disabled={uploadingMicroId === micro._id}
                      >
                        {uploadingMicroId === micro?._id ? (
                          <CircularProgress size={24} color="success" />
                        ) : (
                          <UploadFileIcon color="success" />
                        )}
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {paginatedMicros?.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} sx={{ padding: 0 }}>
                  <img
                    src={noData}
                    style={{ margin: "auto" }}
                    width="50%"
                    height="50%"
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MicrobiologyReportsDynamics;
